import React from 'react';
import { NSFilters } from 'aqlrc';
import { withI18next } from '../lib/withI18n';

class Filters extends NSFilters {
    onChange = async (e, isNumber = undefined, checked = undefined, elemt = undefined, filterP) => {
        const { filters } = this.state;
        const { lang } = this.state;
        if (checked === false) {
            const arr = this.state.checkedArray;
            arr.push(elemt);
            // Ajout d'un element au filtre
            if (filters.$and === undefined) {
                filters.$and = [];
            }
            const element = filters.$and.find((elem) => elem.attributes && elem.attributes.$elemMatch.id === e.target.name);
            const index   = filters.$and.findIndex((elem) => elem.attributes && elem.attributes.$elemMatch.id === e.target.name);
            if (index > -1 && element !== undefined && element.attributes.$elemMatch[`translation.${lang}.value`].$in.length !== undefined) {
                filters.$and[index].attributes.$elemMatch[`translation.${lang}.value`].$in.push(isNumber ? parseInt(e.target, 10) : (e.target.value === 'true' || e.target.value === 'false' ? e.target.value === 'true' : e.target.value.toString()));
            } else {
                filters.$and.push({
                    attributes : {
                        $elemMatch : {
                            [`translation.${lang}.value`] : { $in: [isNumber ? parseInt(e.target.value, 10) : (e.target.value === 'true' || e.target.value === 'false' ? e.target.value === 'true' : e.target.value.toString())] },
                            id                            : e.target.name,
                        },
                    },
                });
            }
            window.localStorage.setItem('filters', JSON.stringify({ category: this.props.location, filters, checkedArray: arr }));
            this.setState({ filters, checkedArray: arr });
        } else {
            // Suppression d'un element du filtre
            const index = filters.$and.findIndex((elem) => elem && elem.attributes && elem.attributes.$elemMatch.id === e.target.name);
            if (filters.$and[index]) {
                filters.$and[index].attributes.$elemMatch[`translation.${lang}.value`].$in.splice(filters.$and[index].attributes.$elemMatch[`translation.${lang}.value`].$in.findIndex((elem) => elem == e.target.value), 1);
                if (filters.$and[index].attributes.$elemMatch[`translation.${lang}.value`].$in.length === 0 && index > -1) {
                    delete filters.$and.splice(index, 1);
                }
                if (!filters.$and.length) {
                    delete filters.$and;
                }
                const arr = this.state.checkedArray;
                arr.splice(arr.findIndex((el) => el === elemt), 1);
                window.localStorage.setItem('filters', JSON.stringify({ category: this.props.location, filters, checkedArray: arr }));
                this.setState({ filters, checkedArray: arr });
            }
        }
        this.props.reload(1, this.props.itemspp, undefined, filters, '.section--sidebar');
        await this.changeFilters(filterP, filters, checked);
    };

    render() {
        const { t } = this.props;
        const { filtersData } = this.state;
        return (
            <div className="sidebar color-gray">
                <div className="sidebar__bg op-2 color-graylight" />{/* <!-- /.sidebar__bg --> */}

                <div className="sidebar__inner">
                    <h4>{t('category:filtrerPar')}</h4>

                    {
                        filtersData.attributes ? filtersData.attributes.map((filter) => (
                            <>
                                <ul className="sidebar__inner_title" key={filter._id}>
                                    <li>
                                        <h4>{filter.name}</h4>
                                    </li>
                                </ul>
                                <ul className={filter.type === 'Couleur' || filter.type === 'color' ? 'list-checkboxes-color' : ''}>
                                    {
                                        filtersData.attributesValues && filtersData.attributesValues[filter.id_attribut] ? filtersData.attributesValues[filter.id_attribut].map((f, index) => (
                                            <li key={`${filter._id}_${index}`}>
                                                <div className="checkbox">
                                                    <input
                                                        type="checkbox"
                                                        name={filter.id_attribut}
                                                        id={`check-filter-${filter.id_attribut}-${index}`}
                                                        value={f}
                                                        checked={this.state.checkedArray.includes(`check-filter-${filter.id_attribut}-${index}`)}
                                                        onChange={(e) => this.onChange(e, typeof f === 'number', this.state.checkedArray.includes(`check-filter-${filter.id_attribut}-${index}`), `check-filter-${filter.id_attribut}-${index}`, filter)}
                                                    />

                                                    {
                                                        filter.type === 'Couleur' || filter.type === 'color' ? (
                                                            <label className="color_filter" style={{ backgroundColor: f.toString() }} htmlFor={`check-filter-${filter.id_attribut}-${index}`} />
                                                        ) : (
                                                            <label htmlFor={`check-filter-${filter.id_attribut}-${index}`}>
                                                                {t(f.toString())}
                                                                <span className="cross">X</span>
                                                            </label>
                                                        )
                                                    }
                                                </div>{/* <!-- /.checkbox --> */}
                                            </li>
                                        )) : null
                                    }
                                </ul>
                            </>
                        )) : 'Aucun filtre disponible'
                    }
                </div>{/* <!-- /.sidebar__inner --> */}

                <div className="sidebar__actions">
                    <button type="button" className="btn btn--color color-gray" onClick={this.resetFilters}><span className="btn__content">{t('category:reset_filters')}</span></button>
                </div>{/* <!-- /.sidebar__actions --> */}
            </div>/* <!-- /.sidebar color-gray --> */
        );
    }
}

export default withI18next([])(Filters);
